/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('DOMContentLoaded', function() {
  if (typeof window.product === 'undefined' || !window.product.variants) {
    console.error('Product data is not available');
    return;
  }

  const variantRadios = document.querySelectorAll('.ProductForm__Variants input[type="radio"]');
  const plannedDateContainer = document.getElementById('planned-shipping-date');
  const stockStatusContainer = document.getElementById('stock-status-container');

  function updatePlannedDateAndStockStatus(selectedVariant) {
    if (!selectedVariant) {
      console.error('Selected variant is undefined');
      return;
    }

    // Retrieve product brand and assign days
    let productBrand = '';
    let days = '5-10';
    if (window.product.vendor) {
      productBrand = window.product.vendor.toLowerCase();
      if (productBrand === 'woodive') {
        /* CLAUDE 2026-10-07 (Michał: „akceptuje” Z-000009 — „po zmianie wariantu lub języka termin zmienia się na 3 dni”):
           było '3', rozjechane z blokiem Liquid w templates/product.json (liquid_KcypXf: woodive → '4-5'), który daje tekst przy pierwszym wejściu.
           Ten motyw = revert_theme_gid aktywnej promocji (id 12) — bez tej poprawki błąd wróciłby po końcu promocji.
           Wycofanie: przywrócić days = '3'. */
        days = '4-5';
      }
    }
 
    const deliveryDays = selectedVariant.metafields && selectedVariant.metafields.delivery_days;
    if (deliveryDays) {
      days = deliveryDays;
      //console.log('delivery days found: ', days);
    } else {
      //console.log('delivery days NOT found');
    }

    // Check the availability of the selected variant
    const isAvailable = selectedVariant.available;
    const plannedDate = selectedVariant.metafields && selectedVariant.metafields.planned_date;
    const userLang = document.documentElement.lang || 'en';

    let displayText = '';
    let stockStatusText = '';
    let stockStatusClass = '';

    if (isAvailable) {
      if (plannedDate) {
        const date = new Date(plannedDate);
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        const formattedDate = new Intl.DateTimeFormat(userLang, options).format(date);

        switch (userLang) {
          case 'en':
            displayText = `Planned Shipping Date: ${formattedDate}`;
            stockStatusText = 'Presale';
            break;
          case 'de':
            displayText = `Geplantes Versanddatum: ${formattedDate}`;
            stockStatusText = 'Vorverkauf';
            break;
          case 'it':
            displayText = `Data di spedizione prevista: ${formattedDate}`;
            stockStatusText = 'Prevendita';
            break;
          case 'nl':
            displayText = `Geplande verzenddatum: ${formattedDate}`;
            stockStatusText = 'Voorverkoop';
            break;
          case 'fr':
            displayText = `Date d'expédition prévue : ${formattedDate}`;
            stockStatusText = 'Prévente';
            break;
          default:
            displayText = `Planned Shipping Date: ${formattedDate}`;
            stockStatusText = 'Presale';
        }

        stockStatusClass = 'presale';
      } else {
        switch (userLang) {
          case 'en':
            displayText = `Shipping within ${days} working days`;
            break;
          case 'de':
            displayText = `Versand innerhalb von ${days} Werktagen`;
            break;
          case 'it':
            displayText = `Spedizione entro ${days} giorni lavorativi`;
            break;
          case 'nl':
            displayText = `Verzending binnen ${days} werkdagen`;
            break;
          case 'fr':
            displayText = `Expédition sous ${days} jours ouvrés`;
            break;
          default:
            displayText = `Shipping within ${days} working days`;
        }

        stockStatusText = '';
        stockStatusClass = '';
      }
    } else {
      displayText = '';
      stockStatusText = '';
      stockStatusClass = '';
    }

    plannedDateContainer.innerHTML = displayText ? `${displayText}` : '';
    stockStatusContainer.innerHTML = stockStatusText;
    stockStatusContainer.className = `stock-status ${stockStatusClass}`;
    if (!stockStatusText) {
      stockStatusContainer.style.display = 'none';
    } else {
      stockStatusContainer.style.display = 'inline-block';
    }
  }

  function getVariantIdFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('variant');
  }

  function handleVariantChange() {
    const selectedVariantId = getVariantIdFromUrl();

    if (selectedVariantId === null) {
      console.error('Could not find variant ID in URL');
    } else {
      const selectedVariant = window.product.variants.find(variant => variant.id == selectedVariantId);
      if (!selectedVariant) {
        console.error('Could not find variant with ID:', selectedVariantId);
      } else {
        //console.log("HandleVariantChange")
        updatePlannedDateAndStockStatus(selectedVariant);
      }
    }
  }

  // Initial load
  const initialVariantId = getVariantIdFromUrl();

  if (initialVariantId === null) {
    console.error('Could not find initial variant ID in URL');
  } else {
    const initialVariant = window.product.variants.find(variant => variant.id == initialVariantId);
    if (!initialVariant) {
      console.error('Could not find initial variant with ID:', initialVariantId);
    } else {
      updatePlannedDateAndStockStatus(initialVariant);
    }
  }

  if (variantRadios.length && plannedDateContainer) {
    //console.log('MK1')
    variantRadios.forEach(function(radio) {
      radio.addEventListener('change', function() {
        // Small delay to ensure URL is updated
        setTimeout(handleVariantChange, 100);
      });
    });
  } else {
    console.error('Variant radios or planned date container not found');
  }
});

(function() {
  // Only run on English product pages (no /de or /nl prefix)
  if (!window.location.pathname.match(/^\/products\//)) return;

  // Skip redirect if user already chose language manually
  if (document.cookie.includes('lang_selected=1')) return;

  var userLang = (navigator.language || navigator.userLanguage || '').toLowerCase();

  var localeMap = {
    'de': '/de',
    'de-de': '/de',
    'nl': '/nl',
    'nl-nl': '/nl'
  };

  var redirectPrefix = null;
  for (var key in localeMap) {
    if (userLang.startsWith(key)) {
      redirectPrefix = localeMap[key];
      break;
    }
  }

  if (!redirectPrefix) return;

  // Perform redirect without setting a cookie
  var path = window.location.pathname;
  var newUrl = window.location.origin + redirectPrefix + path + window.location.search + window.location.hash;
  window.location.replace(newUrl);
})();

document.addEventListener('DOMContentLoaded', function () {
  const localeButtons = document.querySelectorAll('button[name="locale_code"]');
  localeButtons.forEach(function(button) {
    button.addEventListener('click', function () {
      document.cookie = "lang_selected=1; path=/; max-age=31536000"; // 1 year
    });
  });
});
